<template>
    <ul class="right-list-container">
        <li v-for="(item, i) in list" :key="i">
            <a :class="{ active: item.isSelected }" @click="handleClick(item.anchor)" class="category-item-list">{{
                item.name }}</a>
            <RightList :list="item.children" @select="handleClick"></RightList>
        </li>

    </ul>
</template>

<script>
export default {
    name: 'RightList',
    props: ['list'],
    methods: {
        handleClick(id) {
            this.$emit('select', id)
        }
    }
}
</script>

<style scoped lang="less">
.right-list-container {
    box-sizing: border-box;
    padding-left: 25px;

    li {
        list-style: none;
        min-height: 40px;
        line-height: 40px;
        padding: 10px 0;
    }

    .category-item-list {
        cursor: pointer;
        text-decoration: none;
        color: #000;
        font-size: 16px;
    }

    .category-item-list:hover {
        color: #00008B
    }

    .active {
        color: rgb(253, 0, 0)
    }
}
</style>